import { useLang } from "@/i18n";
import { Flame } from "lucide-react";

const LEVEL_COLORS = {
  state: "bg-emerald-800",
  district: "bg-teal-700",
  block: "bg-amber-600",
  city: "bg-blue-700",
  village: "bg-green-700",
};

export default function IDCard({ member }) {
  const { t } = useLang();
  const levelLabels = {
    state: t.level_state,
    district: t.level_district,
    block: t.level_block,
    city: t.level_city,
    village: t.level_village,
  };
  const joinDate = member.created_at
    ? new Date(member.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
    : "-";

  return (
    <div
      className="id-card-print w-[340px] sm:w-[380px] rounded-2xl overflow-hidden shadow-2xl border-2 border-emerald-800 bg-white"
      data-testid="member-id-card"
    >
      <div className="tricolor-bar w-full" />
      <div className="bg-emerald-900 text-white px-5 py-4 flex items-center gap-3">
        <img src="/logo.jpeg" alt="logo" className="w-14 h-14 rounded-full bg-white object-contain p-1" />
        <div>
          <div className="font-heading font-extrabold text-lg leading-tight">समता पार्टी | SAMATA PARTY</div>
          <div className="text-[11px] text-amber-400 font-semibold tracking-wider">महाराष्ट्र प्रदेश | MAHARASHTRA</div>
        </div>
      </div>

      <div className="px-5 py-4">
        <div className="flex gap-4 items-center mb-4">
          {member.photo ? (
            <img src={member.photo} alt={member.name} data-testid="id-card-photo"
              className="w-20 h-24 object-cover rounded-lg border-2 border-emerald-700 shadow" />
          ) : (
            <div className="w-20 h-24 rounded-lg border-2 border-dashed border-emerald-300 bg-emerald-50 flex items-center justify-center" data-testid="id-card-photo-placeholder">
              <Flame className="w-8 h-8 text-emerald-400" />
            </div>
          )}
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-2 flex-wrap mb-2">
              <span className={`text-[11px] font-bold px-3 py-1 rounded-full text-white ${LEVEL_COLORS[member.level] || "bg-emerald-700"}`} data-testid="id-card-level">
                {levelLabels[member.level] || member.level}
              </span>
              <span className="text-[10px] text-slate-500 font-mono" data-testid="id-card-member-id">{member.member_id}</span>
            </div>
            <h3 className="font-heading font-bold text-xl text-emerald-950" data-testid="id-card-name">{member.name}</h3>
          </div>
        </div>

        <div className="space-y-1.5 text-sm">
          <div className="flex justify-between border-b border-emerald-100 pb-1.5">
            <span className="text-slate-500">{t.designation}</span>
            <span className="font-semibold text-emerald-950" data-testid="id-card-designation">{member.designation || "Member"}</span>
          </div>
          <div className="flex justify-between border-b border-emerald-100 pb-1.5">
            <span className="text-slate-500">{t.district}</span>
            <span className="font-semibold text-emerald-950" data-testid="id-card-district">{member.district}</span>
          </div>
          <div className="flex justify-between border-b border-emerald-100 pb-1.5">
            <span className="text-slate-500">{t.mobile_label}</span>
            <span className="font-semibold text-emerald-950" data-testid="id-card-mobile">{member.mobile}</span>
          </div>
          <div className="flex justify-between pb-1.5">
            <span className="text-slate-500">{t.joining_date}</span>
            <span className="font-semibold text-emerald-950" data-testid="id-card-joining-date">{joinDate}</span>
          </div>
        </div>
      </div>

      <div className="bg-emerald-50 px-5 py-3 text-[10px] text-emerald-900 text-center">
        Office No.2, Ghodge Sadan, Wadeghar Circle, Kalyan West 421301 | 9324899996
      </div>
      <div className="tricolor-bar w-full" />
    </div>
  );
}
